import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type TrackedPdfSplitJob = {
  label: string;
  /** Where the job lives in Automations; unknown for entries saved
   * before split jobs moved there (they go through /splitting-tools/:id). */
  userId?: number | null;
  majorJobId?: number | null;
};

export type PdfSplitJobsState = {
  jobs: Record<string, TrackedPdfSplitJob>;
};

const initialState: PdfSplitJobsState = {
  jobs: {},
};

const pdfSplitJobsSlice = createSlice({
  name: "pdfSplitJobs",
  initialState,
  reducers: {
    trackPdfSplitJob: (
      state,
      action: PayloadAction<{
        jobId: string;
        label: string;
        userId?: number | null;
        majorJobId?: number | null;
      }>,
    ) => {
      const { jobId, label, userId, majorJobId } = action.payload;
      state.jobs[jobId] = { label, userId: userId ?? null, majorJobId: majorJobId ?? null };
    },
    removePdfSplitJob: (state, action: PayloadAction<{ jobId: string }>) => {
      delete state.jobs[action.payload.jobId];
    },
    hydratePdfSplitJobs: (
      state,
      action: PayloadAction<PdfSplitJobsState["jobs"]>,
    ) => {
      state.jobs = action.payload ?? {};
    },
    resetPdfSplitJobs: (state) => {
      state.jobs = {};
    },
  },
});

export const {
  trackPdfSplitJob,
  removePdfSplitJob,
  hydratePdfSplitJobs,
  resetPdfSplitJobs,
} = pdfSplitJobsSlice.actions;
export default pdfSplitJobsSlice.reducer;
